/*=========================================================================================
  File Name: customer.js
  Description: Customer Local Storage
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/

function storeCustomerInfo(info) {
    localStorage.setItem('customer', JSON.stringify(info));
}

function storeComment(comment) {
    localStorage.setItem('comment', comment);
}

function getComment() {
    let comment = localStorage.getItem('comment');
    localStorage.setItem('comment', '');
    return comment;
}

function getCustomerInfo() {
    let info = localStorage.getItem('customer'); 
    return JSON.parse(info);
}

function clearCustomerInfo() {
    localStorage.removeItem('customer');
}

export default {
    storeCustomerInfo,
    getCustomerInfo,
    clearCustomerInfo,
    storeComment,
    getComment
}